import { actions } from '../constants/message';
import * as actionTypes from '../../models/action/messages';
import {
    IContact,
    IContactOrGroupRequest,
    IMessageListRequest,
    IMessage,
    IMessageRequest,
    IConversationListRequest,
    IConversation,
    IGroup
} from '../../models/pages/messages';

export function GetUnreadMessageCount(isOnlyCount?: boolean, showTopNotification?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.IGetUnreadMessageCount {
    return{
        isOnlyCount,
        showTopNotification,
        timestamp: Date.now(),
        type: actions.GET_UNREAD_MESSAGE_COUNT,
        spinnerId,
        spinnerType
    };
}

export function SetUnreadMessageCount(unreadMessageCount?: number, isOnlyCount?: boolean, spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.ISetUnreadMessageCount {
    return{
        unreadMessageCount,
        isOnlyCount,
        timestamp: Date.now(),
        type: actions.SET_UNREAD_MESSAGE_COUNT,
        spinnerId,
        spinnerType
    };
}

export function getContactsAction(request: IContactOrGroupRequest): actionTypes.IContactsGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_CONTACTS,
        params: request,
        spinnerId: request.spinnerId,
        spinnerType: request.spinnerType
    };
}

export function setContactsAction(
    take: number,
    skip: number,
    totalCount: number,
    users: IContact[],
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IContactsSetAction {
    return {
        take,
        skip,
        totalCount,
        users,
        timestamp: Date.now(),
        type: actions.SET_CONTACTS,
        spinnerId,
        spinnerType
    };
}

export function getGroupsAction(request: IContactOrGroupRequest): actionTypes.IGroupsGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_GROUPS,
        params: request,
        spinnerId: request.spinnerId,
        spinnerType: request.spinnerType
    };
}

export function setGroupsAction(
    take: number,
    skip: number,
    totalCount: number,
    groups: IGroup[],
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IGroupsSetAction {
    return {
        take,
        skip,
        totalCount,
        groups,
        timestamp: Date.now(),
        type: actions.SET_GROUPS,
        spinnerId,
        spinnerType
    };
}

export function getMessageListAction(request: IMessageListRequest): actionTypes.IMessagesGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_MESSAGE_LIST,
        params: request,
        spinnerId: request.spinnerId,
        spinnerType: request.spinnerType,
        callback: request.callback
    };
}

export function setMessageListAction(
    messages: IMessage[],
    originMessageId: string | null | undefined,
    skip: number,
    take: number,
    total: number,
    chatTitleText: string,
    imageUrl: string,
    contextId: string | undefined,
    contextType: number,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: () => void,
): actionTypes.IMessagesSetAction {
    return {
        messages,
        timestamp: Date.now(),
        type: actions.SET_MESSAGE_LIST,
        spinnerId,
        spinnerType,
        skip,
        contextId,
        contextType,
        imageUrl,
        take,
        total,
        chatTitleText,
        originMessageId,
        callback: callback
    };
}

export function getLoadMoreMessages(request: IMessageListRequest): actionTypes.IMessagesGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_LOAD_MORE_MESSAGES,
        params: request,
        spinnerId: request.spinnerId,
        spinnerType: request.spinnerType
    };
}

export function setLoadMoreMessages(
    messages: IMessage[],
    originMessageId: string | null | undefined,
    skip: number,
    take: number,
    total: number,
    chatTitleText: string,
    imageUrl: string,
    contextId: string | undefined,
    contextType: number,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IMessagesSetAction {
    return {
        messages,
        timestamp: Date.now(),
        type: actions.SET_LOAD_MORE_MESSAGES,
        spinnerId,
        spinnerType,
        skip,
        contextId,
        contextType,
        imageUrl,
        take,
        total,
        chatTitleText,
        originMessageId
    };
}

export function getDeleteAllMessages(
    originMessageId: string,
    deleteType: number,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: string) => void
): any {
    return {
        originMessageId,
        deleteType,
        timestamp: Date.now(),
        type: actions.GET_DELETE_MESSAGES,
        spinnerId,
        spinnerType,
        callback
    };
}

export function sendMessageAction(request: IMessageRequest, callback: any): actionTypes.ISendMessageAction {
    return {
        timestamp: Date.now(),
        type: actions.SEND_MESSAGE,
        params: request,
        callback
    };
}

export function setSentMessageAction(message: IMessage): actionTypes.ISetSentMessageAction {
    return {
        message,
        timestamp: Date.now(),
        type: actions.SET_SENT_MESSAGE
    };
}

export function getConversationListAction(request: IConversationListRequest): actionTypes.IConversationListGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_CONVERSATION_LIST,
        params: request,
        spinnerId: request.spinnerId,
        spinnerType: request.spinnerType,
        callback: request.callback
    };
}

export function getHeaderMessageListAction(request: IConversationListRequest): actionTypes.IConversationListGetAction {
    return {
        timestamp: Date.now(),
        type: actions.GET_HEADER_MESSAGE_LIST,
        params: request,
        spinnerId: request.spinnerId,
        spinnerType: request.spinnerType,
        callback: request.callback
    };
}

export function setConversationListAction(
    totalCount: number,
    conversations: IConversation[],
    take: number,
    isGroup: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IConversationListSetAction {
    return {
        totalCount,
        conversations,
        take,
        isGroup,
        timestamp: Date.now(),
        type: actions.SET_CONVERSATION_LIST,
        spinnerId,
        spinnerType
    };
}

export function setHeaderMessageListAction(
    totalCount: number,
    conversations: IConversation[],
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IHeaderMessageSetAction {
    return {
        totalCount,
        conversations,
        timestamp: Date.now(),
        type: actions.SET_HEADER_MESSAGE_LIST,
        spinnerId,
        spinnerType
    };
}

export function getHomeBoxGetAction(
    Filters: actionTypes.IFilters,
    IsAll: boolean,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: any
): actionTypes.IGetHomeBox {
    return {
        Filters,
        IsAll,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_HOME_BOX,
        callback
    };
}

export function getHomeBoxSetAction(HomeBoxMessages: any | null, spinnerId?: string, spinnerType?: 'get' | 'set',islastMessage?: boolean): actionTypes.ISetHomeBox {
    return {
        HomeBoxMessages,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_HOME_BOX,
        isLastMessage : islastMessage
    };
}

export function setChatPanelMessagesDefault() {
    return {
        timestamp: Date.now(),
        type: actions.SET_DEFAULT_CHATPANEL_MESSAGE
    };
}
export function setUnreadMessageCountAction(response: any, spinnerId: any): actionTypes.ISetUnreadMessageCount {
    return {
        unreadMessageCount: response.unreadMessageCount,
        spinnerId,
        timestamp: Date.now(),
        type: actions.SET_UNREAD_MESSAGE_COUNT
    };
}

export function GetReadMessages(spinnerId?: string, spinnerType?: 'get' | 'set') : actionTypes.IGetReadMessages {
    return{
        timestamp: Date.now(),
        type: actions.GET_READ_MESSAGES,
        spinnerId,
        spinnerType
    };
}

export function setOriginMessageIdAction(
    originMessageId: string | null | undefined,
    chatTitleText: string,
    imageUrl: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: () => void,
): actionTypes.ISetOriginMessageIdAction {
    return {
        timestamp: Date.now(),
        type: actions.SET_ORIGIN_MESSAGE_ID,
        spinnerId,
        spinnerType,
        originMessageId,
        chatTitleText,
        imageUrl,
        callback: callback
    };
}



